import React, {Component} from 'react';
import {LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid} from 'recharts';

class AccountsIdentifiedForOptimizationGraph extends Component{

  constructor(props){
    super(props)
    this.state={data:this.props.data}
  }

  render(){
    return(
      <ResponsiveContainer>
        <LineChart data={this.state.data}>
          <XAxis dataKey={"month"}/>
          <YAxis scale={'linear'}/>
          <CartesianGrid/>
          <Tooltip/>
          <Line type={"linear"} name={"Dif. Uso de suelo"} dataKey={"landUse"} stroke={"#222"} />
          <Line type={"linear"} name={"Dif. M2 suelo"} dataKey={"floor"} stroke={"#777"} />
          <Line type={"linear"} name={"Dif. M2 construcción"} dataKey={"construction"} stroke={"#C79B6E"} />
        </LineChart>
      </ResponsiveContainer>
    );
  }

}

export default AccountsIdentifiedForOptimizationGraph;



// WEBPACK FOOTER //
// ./src/charts/accountsIdentifiedForOptimizationGraph.js